// src/admin/OrderCard.js
import React from 'react';
import { formatDateFriendly } from '../utils/dateUtils';

/**
 * مكون بطاقة الطلب المستخدم في طريقة العرض البديلة
 */
const OrderCard = ({ order, onDetails, onTrack, onDelete, isSelected, onSelect }) => {
  // التحقق من وجود الطلب
  if (!order) return null;

  // تحديد لون حالة الطلب وتصنيفها
  const getStatusClass = (status) => {
    if (status?.includes("تم التسليم")) return "status-delivered";
    if (status?.includes("تم الاستلام")) return "status-pickup";
    if (status?.includes("ملغي")) return "status-cancelled";
    return "status-pending";
  };

  // تنسيق المبلغ بالدينار الكويتي
  const formatAmount = (amount) => {
    if (amount === undefined || amount === null) return "0.000 د.ك";
    return `${Number(amount).toFixed(3)} د.ك`;
  };

  // تنسيق وقت إنشاء الطلب
  const orderDate = formatDateFriendly(order.createdAt);

  return (
    <div className={`order-card ${isSelected ? 'selected' : ''}`}>
      <div className="order-card-header">
        <div className="order-card-checkbox-container">
          <input 
            type="checkbox" 
            checked={isSelected}
            onChange={() => onSelect(order.id)}
            className="order-card-checkbox"
          />
        </div>
        <div className="order-card-id">
          {order.orderCode || `#${order.id.substring(0, 8)}`}
        </div>
        <div className={`order-card-status ${getStatusClass(order.status)}`}>
          {order.status || "غير معروف"}
        </div>
      </div>
      
      <div className="order-card-body">
        <div className="order-card-section">
          <div className="order-card-section-header">
            <i className="fas fa-user"></i>
            <span>العميل</span>
          </div>
          <div className="order-card-info">
            <span className="order-card-name">{order.customerName || "غير معروف"}</span>
            <span className="order-card-phone">{order.phone || "لا يوجد رقم"}</span>
          </div>
        </div>
        
        <div className="order-card-section">
          <div className="order-card-section-header">
            <i className="fas fa-store"></i>
            <span>المطعم</span>
          </div>
          <div className="order-card-info">
            <span>{order.restaurantName || "غير معروف"}</span>
          </div>
        </div>
        
        <div className="order-card-section">
          <div className="order-card-section-header">
            <i className="fas fa-motorcycle"></i>
            <span>السائق</span>
          </div>
          <div className="order-card-info">
            <span>{order.driverName || "غير معروف"}</span>
          </div>
        </div>
        
        <div className="order-card-section">
          <div className="order-card-section-header">
            <i className="fas fa-money-bill"></i>
            <span>المبلغ</span>
          </div>
          <div className="order-card-info">
            <div className="order-card-amount-details">
              <div className="order-card-amount-row">
                <span>الطلب:</span>
                <span>{formatAmount(order.amount)}</span>
              </div>
              <div className="order-card-amount-row">
                <span>التوصيل:</span>
                <span>{formatAmount(order.deliveryFee)}</span>
              </div>
              <div className="order-card-amount-row order-card-total">
                <span>الإجمالي:</span>
                <span>{formatAmount(order.totalAmount || (order.amount + order.deliveryFee))}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="order-card-section">
          <div className="order-card-section-header">
            <i className="fas fa-clock"></i>
            <span>الوقت</span>
          </div>
          <div className="order-card-info">
            <span>{orderDate}</span>
          </div>
        </div>
        
        <div className="order-card-address">
          <i className="fas fa-map-marker-alt"></i>
          <span>{order.address || "لا يوجد عنوان"}</span>
        </div>
      </div>
      
      <div className="order-card-footer">
        <button 
          className="order-card-button details"
          onClick={() => onDetails(order)}
        >
          <i className="fas fa-info-circle"></i>
          تفاصيل
        </button>
        <button 
          className="order-card-button track"
          onClick={() => onTrack(order)}
        >
          <i className="fas fa-map-marked-alt"></i>
          تتبع
        </button>
        <button 
          className="order-card-button delete"
          onClick={() => onDelete(order)}
        >
          <i className="fas fa-trash-alt"></i>
          حذف
        </button>
      </div>
    </div>
  );
};

export default OrderCard;